import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function CTASection() {
  return <section className="w-full py-16" style={{
    backgroundColor: 'white'
  }} data-id="element-21">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-23">
          <h3 className="font-handwritten text-3xl md:text-4xl" style={{
          color: 'var(--color-green)'
        }} data-id="element-24">
            Gib deinem Hund das Beste
          </h3>
          <p className="text-base md:text-lg max-w-xl mx-auto leading-relaxed" style={{
          color: 'var(--color-text)'
        }} data-id="element-25">
            Wenn dein Hund auch unter Verdauungsproblemen leidet, probiere das
            natürliche Futtertopping aus. Es hat Lunas Leben verändert –
            vielleicht verändert es auch das deines Hundes.
          </p>

          <motion.a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-semibold text-lg shadow-lg transition-shadow hover:shadow-xl" style={{
          backgroundColor: 'var(--color-green)'
        }} data-id="element-26">
            Jetzt für deinen Hund entdecken
            <ArrowRightIcon className="w-5 h-5" data-id="element-27" />
          </motion.a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2" data-id="element-28">
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-29">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-30" />
              Schneller Versand
            </div>
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-31">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-32" />
              Zufriedenheitsgarantie
            </div>
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-33">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-34" />
              Natürliche Inhaltsstoffe
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}